// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getEnvironmentValue = (envKey: string): string | undefined => (window as any).__ENVIRONMENT__?.[envKey]

export const getAPIURL = () => getEnvironmentValue('API_URL') ?? ''
export const apiPath = '/graphql'
